import React, { ReactNode, useState } from "react";
import { MenuItemProps } from "./menu-item";

const initialState = undefined;

export type SideBarMenuProviderProps = {
  children: ReactNode;
};

export type SideBarMenuContextValue = {
  selectedItemSubmenu: MenuItemProps | undefined;
  setSelectedItemSubmenu: React.Dispatch<React.SetStateAction<MenuItemProps | undefined>>;
  selectedItemMainMenu: MenuItemProps | undefined;
  setSelectedItemMainMenu: React.Dispatch<
    React.SetStateAction<MenuItemProps | undefined>
  >;
  itemMainMenuWDataLoading: string | undefined;
  setItemMainMenuWDataLoading: React.Dispatch<React.SetStateAction<string | undefined>>;
  hideBar: boolean;
  setHideBar: React.Dispatch<React.SetStateAction<boolean>>;
  showTopMenu: boolean | undefined;
  setShowTopMenu: React.Dispatch<React.SetStateAction<boolean>>;
};

export const SideBarMenuContext =
  React.createContext<SideBarMenuContextValue>({
    selectedItemSubmenu: initialState,
    setSelectedItemSubmenu: () => { },
    selectedItemMainMenu: initialState,
    setSelectedItemMainMenu: () => { },
    itemMainMenuWDataLoading: initialState,
    setItemMainMenuWDataLoading: () => { },
    hideBar: false,
    setHideBar: () => { },
    showTopMenu: true,
    setShowTopMenu: () => { }
  });

export function SideBarMenuContextProvider({ children }: SideBarMenuProviderProps) {
  const [selectedItemSubmenu, setSelectedItemSubmenu] = useState<MenuItemProps | undefined>(
    initialState
  );
  const [selectedItemMainMenu, setSelectedItemMainMenu] =
    useState<MenuItemProps | undefined>(initialState);
  const [itemMainMenuWDataLoading, setItemMainMenuWDataLoading] =
    useState<string | undefined>('');
  const [hideBar, setHideBar] =
    useState<boolean>(false);
  const [showTopMenu, setShowTopMenu] =
    useState<boolean>(true);
  return (
    <SideBarMenuContext.Provider
      value={{
        selectedItemSubmenu,
        setSelectedItemSubmenu,
        selectedItemMainMenu,
        setSelectedItemMainMenu,
        itemMainMenuWDataLoading,
        setItemMainMenuWDataLoading,
        hideBar,
        setHideBar,
        showTopMenu,
        setShowTopMenu
      }}
    >
      {children}
    </SideBarMenuContext.Provider>
  );
}
